<script>
  import { onMount } from "svelte";

  export let inputText;
  export let callBack = null;

  let text = "";
  let index = 0;
  let updater;

  // Update the text
  const updateText = () => {
    if (index + 1 == inputText.length) clearInterval(updater);

    text += inputText[index++];
  };

  // Start the typing effect
  onMount(() => (updater = setInterval(updateText, 50)));
</script>

<h2>{text}</h2>
